import { useState, useCallback } from 'react';
import {
  handleMarkPaid as breadMarkPaid,
  loadBreadLogs,
} from '../services/api/breadService';
import { logger } from '../utils/logger';
import { isDemoMode } from '../utils/demoUtils';
import { mockDB } from '../services/mock/mockData';

const useMockData = false; // Use API data

export function useBreadData(userProfile, players, setPlayers) {
  const [breadLogs, setBreadLogs] = useState([]);
  const [breadSortField, setBreadSortField] = useState('sliceValue');
  const [breadSortDirection, setBreadSortDirection] = useState('desc');

  // Load bread logs data
  const loadBreadLogsData = useCallback(async () => {
    if (isDemoMode()) {
      logger.debug('Demo Mode: Loading mock bread logs');
      const logs = mockDB.getBreadLogs();
      setBreadLogs(logs);
      return logs;
    }

    if (useMockData) return;

    try {
      const logsResult = await loadBreadLogs();
      setBreadLogs(logsResult);
      return logsResult;
    } catch (error) {
      logger.error('Error loading bread logs data:', error);
      throw error;
    }
  }, []);

  // Bread operations
  const handleMarkPaid = async (playerId, type, loadPlayersData) => {
    let newLog;

    if (isDemoMode()) {
      // Use Mock DB in Demo Mode
      const player = players.find(p => p.id === playerId);
      const logData = {
        playerId,
        playerName: player?.name || 'Unknown Player',
        type: type === 'full' ? 'Full Slice Eaten' : 'Half Slice Eaten',
        action: 'consumed',
        adminName: userProfile?.name || 'Admin',
        adminEmail: userProfile?.email || 'admin@office-arena.local'
      };
      newLog = mockDB.addBreadLog(logData);
      logger.debug('Demo Mode: Added mock bread log', newLog);
    } else {
      newLog = await breadMarkPaid(
        playerId,
        type,
        userProfile,
        players,
        setPlayers
      );
    }

    if (newLog) {
      // Add to UI only after successful API response
      // Use the exact timestamp from the server to ensure correct ordering
      setBreadLogs(prevLogs => [newLog, ...prevLogs]);

      // Reload player data to get updated debt calculations
      if (loadPlayersData) {
        await loadPlayersData();
      }

      logger.debug('Bread payment recorded successfully:', newLog.id);
      return true;
    }

    logger.warn('Bread payment failed - no log returned from API');
    return false;
  };

  return {
    // State
    breadLogs,
    breadSortField,
    breadSortDirection,
    setBreadLogs,
    setBreadSortField,
    setBreadSortDirection,

    // Operations
    loadBreadLogsData,
    handleMarkPaid,
  };
}
